import { BrowserRouter, Routes, Route } from "react-router-dom"

import Dashboard from "./pages/Dashboard";
import Orders from "./pages/Orders";
import Analytics from "./pages/Analytics";
import Accounting from "./pages/Accounting";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="" element={<Dashboard/>}/>
          <Route path="/orders" element={<Orders/>}/>
          <Route path="/analytics" element={<Analytics/>}/>
          <Route path="/accounting" element={<Accounting/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
